import React, { useState, useEffect, useRef } from "react";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { UrlPath } from "../../../config/routeConfig";
import { TopBar } from "../../shared/topBar/TopBar";
import { useNavigate, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { SBADropDown, SBAComboBox } from "../../UiComponents/SBADropDown";
import { getPortFolioListAction, getPortFolioCashAction } from "../../actions/portfolioAction";
import { getTransactionStatusAction } from "../../actions/transactionAction";
import { sbaAxios } from "../../utils/sbaAxios";
import { SBDatePicker } from "../../UiComponents/SBDatePicker";
import { SBNotify } from "../../utils/sbNotify";
import { ToastContainer } from "react-toastify";
import moment from "moment";
import { getAssestListddlAction } from '../../actions/assetsddlAction';

import { getAsset, getAssetCurrencyType } from "../../actions/assetAction";
import { getPortfolioDetailAPI,getTransactionAssetsByType,getPortfolioListAPI, insertUpdateReceiveCash, getAssetLotByPortfolio, getPortfolioAssetsById, getTransactionCashByAssetLot, assetDetailsUrl} from "../../../config/apiConfig";
import { AgGridReact } from "ag-grid-react";
import { SBACurrencyInput } from "../../UiComponents/SBACurrencyInput";
import { currencyFormatter, getTransactionByID,getPortfolioListByAssetAndTransType,gettransactionEditAccess } from "../utils";
import { Link } from "react-router-dom";
import { ExchangeRateModal } from "../Components/ExchangeRateModal";
export const ReceiveCash = () => {
    const history = useNavigate();
    const params = useParams();
    const dispatch = useDispatch();
    const Gstate = useSelector((state) => state);
    const transactionId = parseInt(params.TransId) || 0;
    const objType = parseInt(params?.ObjectType);
    const [transactionData, setTransactionData] = useState(plainReceivecash);
    const statusStore = Gstate.transaction.statusList || [];
    const [portfolioList,setPortfolioList]=useState();
    const ToAccountAccount = Gstate.portfolio.cash || [];
    const iseditable = transactionId === 0 ? false : true;
    const [portfolio, setPortfolio] = useState();
    const [AssetList, setAssetList] = useState([]);
    const [assetLots, setAssetLots] = useState([]);
    const [griddata, setgriddata] = useState(plainGriddata);
    const [Isgrid, setIsgrid] = useState(false);
    const tableRef = useRef(null);
    const [showModal, setShowModal] = useState(false);
    const [statusDS, setStatusDS] = useState(statusStore);
    const[transactionEditAccess,setTransactionEditAccess]=useState(false);
    const portfolioVal = { "PortfolioId": transactionData.PortfolioId, "PortfolioName": transactionData.PortfolioName }
    const statusVal = { "TransStatus": transactionData.TradeStatusName, "TransStatusId": transactionData.TradeStatusId };
    const AssetVal = { "AssetId": transactionData.AssetLotAssetId, "AssetName": transactionData.AssetLotAssetName }
    const AssetLotsVal = { "AssetLotId": transactionData.AssetLotId, "AssetLotName": transactionData.AssetLotName }
    const ToAccountsVal = { "AssetId": transactionData.AccountIdToBalance, "AssetName": transactionData.AccountIdToBalanceName }
    const Level = objType == 1 ? [
        {
            BreadCrumb: "Transactions >",
            Routes: `${UrlPath.Transactions}${params.AssetId}`,
        },
        {
            BreadCrumb: "Receive Cash",
            Routes: `${UrlPath.ReceiveCash}${params.AssetId}`,
        },
    ] : [
        {
            BreadCrumb: "Transactions >",
            Routes: `/${UrlPath.portfolioTransaction}${params.EntityId}`,
        },
        {
            BreadCrumb: "Receive Cash",
            Routes: `/${UrlPath.PortfolioReceiveCash}${params.EntityId}`,
        },
    ];
    useEffect(() => {
        document.title = "Transactions ReceiveCash";
    }, []);

    useEffect(() => {
      setTransactionEditUserAccess();
        setStatusDS(statusStore)
        setTransactionData(value => ({ ...value, Status: statusStore[2] }));
    }, [statusStore]);

    useEffect(() => {
        if (objType == 1) {
            
            dispatch(getTransactionStatusAction());
            dispatch(getPortFolioCashAction());
            dispatch(getAssestListddlAction());
            dispatch(getAsset(params?.EntityId));
            setAssetByID(params?.EntityId);
            setPortfolioByAssetId(params?.EntityId);
        } else {
            
            
            dispatch(getTransactionStatusAction());
            dispatch(getPortFolioCashAction());
            dispatch(getAssestListddlAction()); 
            setPortfolioByID(params?.EntityId);
            getAssetListByPortfolioID(params?.EntityId);
           
        }
        setTransactionByID(transactionId);
       
    }, []);

    useEffect(()=>{
        if (objType == 1) {
            setAssetList(Gstate?.assetDDL?.assetList || []);
        }
    },[Gstate?.assetDDL?.assetList ]);
// User Access Rights
const setTransactionEditUserAccess= async()=>
{
    const access = await gettransactionEditAccess();
    setTransactionEditAccess(access);
}
   
    const ToreceivecashOnchange = (e,Id) => {
        const parsedValue = parseFloat(e)  || 0;
        setgriddata(prevData => ({
            ...prevData,
            ChildDetails: prevData.ChildDetails.map(item => {
                if (item.Rowid === Id) {
                   
                    return { ...item, TOCashReceive: parsedValue    };
                  
                } else {
                    return item;
                }
            })
        }));
        const Total = griddata?.ChildDetails.reduce((acc, item) => {
            if (typeof item.TOCashReceive === 'number' && item.Rowid !== Id) {
                return acc + item.TOCashReceive;
            }
            return acc;
        },parsedValue);
        setTransactionData(value => ({ ...value, TransAmount: Total, LocalAmount: transactionData?.ExchangeRate * Total }));

    }
    const handleCheckboxChange = (e,id) => {
        let total = 0;
        setgriddata(prevData => ({
            ...prevData,
            ChildDetails: prevData.ChildDetails.map(item => {
                if (item.Rowid === id) {
                    total += e.target.checked === true ? parseFloat(item.AvailableCashAmount) : parseFloat(item.TOCashReceive);
                    return { ...item, TOCashReceive: e.target.checked === true ? parseFloat(item.AvailableCashAmount) : parseFloat(item.TOCashReceive), ReceiveAll: e.target.checked }

                } else {
                    total += parseFloat(item.TOCashReceive);
                    return item;
                }
            })
        }));
        setTransactionData(value => ({ ...value, TransAmount: total, LocalAmount: transactionData?.ExchangeRate * total }));
    };
    const exchangeRateChange=(e)=>
    {
       const parsedValue = parseFloat(e);
        setTransactionData(value => ({
               ...value,
                 ExchangeRate: parsedValue,
                  LocalAmount: transactionData?.TransAmount * parsedValue
                   }));
             }
    //get asset By Id

    const setAssetByID = async (Id) => {
        try {
            const asset = await getAssetByID(Id);
            setTransactionData(value => ({ ...value, AssetLotAssetName: asset?.AssetName, AssetLotAssetId: asset?.AssetId ,AssetId:asset?.AssetId,AssetName:asset?.AssetName}));
        }
        catch (e) {
            setTransactionData(value => ({ ...value, AssetId: 0, AssetName: '' }));
            setPortfolio({});
        }
    }

    //set portfolio data

    const setPortfolioByID = async (Id) => {
       
        try {
            const portfolio = await getPortfolioDetailsByID(Id);
            setTransactionData(value => ({ ...value, PortfolioId: portfolio?.PortfolioId, PortfolioName: portfolio?.PortfolioName }));
            setPortfolio(portfolio);
        }
        catch (e) {
            setTransactionData(value => ({ ...value, PortfolioId: 0, PortfolioName: '' }));
            setPortfolio({});
        }

    };
    const setPortfolioByAssetId = async (Id) => {
      
        try {
          const portfolio = await getPortfolioListByAssetAndTransType(Id,5);
        const  portfolios= portfolio.map((item) => ({
            'PortfolioName':item.Name,
            'PortfolioId':item.PortfolioId
        }))
          setPortfolioList([]);
          if(portfolios.length>0)
          {
          setPortfolioByID(portfolios[0]?.PortfolioId);
          setTransactionData(value => ({ ...value, "PortfolioName": portfolios[0]?.PortfolioName, "PortfolioId": portfolios[0]?.PortfolioId }));
          }
        }
        catch (e) {
          setTransactionData(value => ({ ...value, PortfolioId: 0, PortfolioName: '' }));
          setPortfolioList([]);
        }
      }
    // Dropdown Control Change Event
    const portfolioDDChng = (e) => {
        if (e.value) {
            setIsgrid(false);
            const portfolio = e.value;
            setPortfolioByID(e.value.PortfolioId);
            setPortfolio(portfolio);
            if (objType == 3) {
                setTransactionData((prevData) => ({ ...prevData, AssetId: 0, AssetName: '', AssetLotId: 0, AssetLotName: '', TransAmount: "0.00", LocalAmount: "0.00"}));
                history(`/${UrlPath.PortfolioReceiveCash}0/${e.value.PortfolioId}/3`);
                getAssetListByPortfolioID(e.value.PortfolioId);
            }
            else if(objType == 1){
                getAssetListByPortfolioID(e.value.PortfolioId);
            }
        else
        {
            getLotsById(e.value.PortfolioId, transactionData.AssetId, transactionData.ShareclassId);
            setTransactionData((prevData) => ({ ...prevData, PortfolioId:e.value.PortfolioId,PortfolioName:e.value.PortfolioName, TransAmount: "0.00", LocalAmount: "0.00"}));
        }
           

        }
    };

    const portfolioFilterChange = (e) => {
        const terms = e.filter.value;
        if (terms.length > 1) {
          setPortfolioByTerm(terms);
        }
        else
        setPortfolioList([]);
      };
      const getPortfolioListByTerms = async (term) => {
        try {
          const response = await sbaAxios({ url: getPortfolioListAPI + '?searchText=' + term });
          return response;
        }
        catch (e) {
          return [];
        }
      };
      const setPortfolioByTerm = async (term) => {
        try {
          const portfolioList = await getPortfolioListByTerms(term);
          setPortfolioList(portfolioList);
        }
        catch (e) {
          console.log(e, 'Error Fetching the data for portfolio');
          setPortfolioList([]);
        }
      };
    const statusDDChng = (e) => {

        if (e.value) {
            setTransactionData(value => ({ ...value, TradeStatusId: e.value.TransStatusId, TradeStatusName: e.value.TransStatus }));
        }
    };
    const assetDropdown = (e) => {
        if (e.value) {
            if(objType===1)
            {
                setPortfolioByAssetId(e.value.AssetId);
                history(`${UrlPath.ReceiveCash}${transactionId}/${e.value.AssetId}/1`);
            }
            //setTransactionData((prevData) => ({ ...prevData, AccountIdToBalance: e.value.AssetId, AccountIdToBalanceName: e.value.AssetName, TransAmount: "0.00", LocalAmount: "0.00", ExchangeRate: "1.00" }));
            setTransactionData((prevData) => ({ ...prevData, AssetName: e.value.AssetName, AssetId: e.value.AssetId, AssetLotAssetId: e.value.AssetId, AssetLotAssetName: e.value.AssetName, TransAmount: "0.00", LocalAmount: "0.00", ExchangeRate: "1.00" }));
            getLotsById(transactionData.PortfolioId, e.value.AssetId, transactionData.ShareclassId);
        }
    }
    const transdateChange = (e) => {
       
        setTransactionData((prevData) => ({ ...prevData, ["TransDate"]: moment(e).format("MM-DD-yyyy") }));
        getTransactionCashByAssetLotID(transactionData.PortfolioId, transactionData.AssetId, transactionData.AssetLotId, moment(e).format("MM-DD-yyyy"));
    }
    const lotDropdown = (e) => {
        if (e.value) {
            setTransactionData((prevData) => ({ ...prevData, AssetLotId: e.value.AssetLotId, AssetLotName: e.value.AssetLotName, IsShareBased: e.value.IsShareBased, TransAmount: "0.00", LocalAmount: "0.00", ExchangeRate:"1.00" }));
            getTransactionCashByAssetLotID(transactionData.PortfolioId, transactionData.AssetId, e.value.AssetLotId, moment(transactionData.TransDate).format("MM-DD-yyyy"));

        }
    }
    const ToAccountDropdown = (e) => {
        if (e.value) {
           
           setTransactionData((prevData) => ({ ...prevData, AccountIdToBalance: e.value.AssetId, AccountIdToBalanceName: e.value.AssetName, IsShareBased: e.value.IsShareBased }));

        }
    }
    // Get Lots By Id start...
    const getLotsById = async (Id, assetId, shareclassId) => {
      
        try {
            const lots = await getAssetLotsByID(Id, assetId, shareclassId);
            if (lots.length > 0)
            {
                setAssetLots(lots);
                if (transactionId === 0) {
                    setTransactionData(value => ({ ...value, AssetLotId: lots[0].AssetLotId, AssetLotName: lots[0].AssetLotName, IsShareBased: lots[0].IsShareBased }))
                    getTransactionCashByAssetLotID(Id, assetId, lots[0].AssetLotId, transactionData.TransDate.toISOString());


                }
                else {
                    getTransactionCashByAssetLotID(Id, assetId, transactionData.AssetLotId, transactionData.TransDate.toISOString());

                }

            }
            else {
                setAssetLots([]);
                setTransactionData(value => ({ ...value, AssetLotId: 0, AssetLotName: "", IsShareBased: false }))
            }
        }
        catch (e) {
            setAssetLots([]);
            setTransactionData(value => ({ ...value, AssetLotId: 0, AssetLotName: "" }))
        }

    };
    const getAssetLotsByID = async (Id, assetId, shareclassId) => {
        try {
            const response = await sbaAxios({
                 
               url: `${getAssetLotByPortfolio}${Id},${assetId},${shareclassId}`,
                method: 'get',
            });

            return response;
        }
        catch (e) {
            console.log(e, 'Error Fetching the Asset lots')
            return {};
        };
    };
// Get Lots By Id End...

// GetHoldbacks 
    const getTransactionCashByAssetLotID = async (Portfolioid, assetId, LotID, TransactionDate) => {
        try {
            const response = await sbaAxios({
                url: `${getTransactionCashByAssetLot}?portfolioId=${Portfolioid}&assetId=${assetId}&assetLotId=${LotID}&transactionDate=${TransactionDate}`,
                method: 'get',
            });
            const lotsdata = response;
            if (lotsdata.length>0) {
                setIsgrid(true);
                const newData = lotsdata?.map((item, index) => ({
                    Rowid: index,
                    AssetLotId: item.AssetLotId,
                    AssetLotName: item.AssetLotName,
                    InitialAllocationDate: item.InitialAllocationDate,
                    AvailableCashAmount: item.AvailableCashAmount,
                    TOCashReceive: item.AvailableCashAmount,
                    ReceiveAll: true,
                    TransId:0
                }));
                setgriddata((value) => { return { ...value, ChildDetails: newData }; })
                const Total = newData.reduce((acc, item) => {

                    if (typeof item.TOCashReceive === 'number') {
                        return acc + item.TOCashReceive;
                    }
                    return acc;
                }, 0);    
                setTransactionData(value => ({ ...value, TransAmount: Total, LocalAmount: transactionData?.ExchangeRate * Total }));
            } else {
                console.log('Response is not an array');
                setgriddata(plainGriddata);
                setIsgrid(false);
            }
        } catch (e) {
            console.log(e, 'Error Fetching the Asset lots')
            
        };
    };
    // Get Assets start..
    const getAssetListByPortfolioID = async (id) => {
        try {
            const res = await getPortfolioExistingAssets(id);
            if (res && res.length > 0) {
                setAssetList(res);

                if (transactionId === 0) {
                    setTransactionData(value => ({ ...value, AssetId: res[0].AssetId, AssetName: res[0].AssetName, AssetLotAssetId: res[0].AssetId, AssetLotAssetName: res[0].AssetName}))
                    getLotsById(id, res[0].AssetId, transactionData.ShareclassId);
                }

            }
            else {
                setAssetList([]);
                setAssetLots([]);
            }
        }
        catch (e) {
            setAssetList([]);
            setAssetLots([]);
        }
    };

    const getPortfolioExistingAssets = async (portfolioId) => {
        try {
            const response = await sbaAxios({
                url: `${getPortfolioAssetsById}${portfolioId},${5}`,
                method: 'get',
            });

            return response;
        }
        catch (e) {
            console.log(e, 'Error Fetching the Asset lots')
            return {};
        };
    };


    // Edit Transaction Data Get 
    const setTransactionByID = async (id) => {
       
        if (id > 0) {
            try {
                const details = await getTransactionByID(id);
                setPortfolioByID(details?.PortfolioId);
                const response = await sbaAxios({
                    url: `${getTransactionCashByAssetLot}?portfolioId=${details.PortfolioId}&assetId=${details.AssetLotAssetId}&assetLotId=${details.AssetLotId}&transactionDate=${details.TransDate}`,
                    method: 'get',
                });
                setTransactionData(details);           
                const lotsdata = details.ChildDetails;
                if (lotsdata.length > 0) {
                    setIsgrid(true);
                    const newData = lotsdata?.map((item, index) => ({
                        Rowid: index,
                        AssetLotId: item.AssetLotId,
                        AssetLotName: item.AssetLotName,
                        InitialAllocationDate: details.InitialAllocationDate,
                        AvailableCashAmount: response.length === 0 ? item.TransAmount: response?.map((res) => res.AssetLotId === item.AssetLotId ? res.AvailableCashAmount + item.TransAmount : "0.00"),
                        TOCashReceive:item.TransAmount,
                        ReceiveAll: false,
                        TransId: item.TransId,
                    }));
                    const child = newData?.map((item, index) => ({
                        ...item,
                        ReceiveAll: item.AvailableCashAmount === item.TOCashReceive ? true : false
                    }));

                    setgriddata((value) => { return { ...value, ChildDetails: child }; })
                    const Total = newData.reduce((acc, item) => {

                        if (typeof item.TOCashReceive === 'number') {
                            return acc + item.TOCashReceive;
                        }
                        return acc;
                    }, 0);
                    setTransactionData(value => ({ ...value, TransAmount:Total, LocalAmount: details.ExchangeRate * Total }));
                } else {
                    console.log('Response is not an array');
                    setgriddata(plainGriddata);
                    setIsgrid(false);
                }


            } catch (e) {
                setTransactionData(plainReceivecash);
                setgriddata(plainGriddata);
            }
        }
        else {
            setIsgrid(false);
            setTransactionData(plainReceivecash);
            setgriddata(plainGriddata);
        }

    };

// Save Data Praperation Start

    const saveReceiveCash = () => {
       
        let saveSuccess = true;
        const newData = griddata.ChildDetails?.map((item, index) => ({
            "transId": item.TransId,
            "assetId": transactionId === 0 ? 3 : transactionData.AssetLotAssetId,
            "assetLotId": item.AssetLotId,
            "transTypeId": 5,
            "transDate": item.InitialAllocationDate,
            "transAmount": item.TOCashReceive,
            "localAmount": transactionData.LocalAmount,
            "transPercentage": 0,
            "shares": 0,
            "transDescription": transactionData.TransDescription ? transactionData.TransDescription : "",
        }));
        const savedata = {
           
            "transId": transactionId,
            "portfolioId": transactionData.PortfolioId,
            "assetId": 3,
            "shareClassId": 0,
            "assetLotId": 0,
            "accountIdToBalance": transactionData.AccountIdToBalance,
            "tradeStatusId": transactionData.TradeStatusId,
            "transTypeId": 5,
            "transDate": transactionData.TransDate,
            "transAmount": transactionData.TransAmount,
            "localAmount": transactionData.LocalAmount,
            "transPercentage": 0,
            "exchangeRateId": 0,
            "exchangeRate": transactionData.ExchangeRate,
            "allocationDate": "",
            "shares": 0,
            "nav": 0,
            "transDescription": transactionData.TransDescription ? transactionData.TransDescription : "",
            "initialAllocationDate": "",
            "isFullRedemption": false,
            "partialRedemptionModeId": 0,
            "isInsurance": false,
            "isFee": false,
            "isShareBased": false,
            "isCommitmentRelease": false,
            "modifiedBy": 0,
            "childTrans": newData
        };

        if (!transactionData.TradeStatusName || transactionData.TradeStatusName === "") {
            SBNotify({ Msg: "Please Select Status ", type: "error" });
            saveSuccess = false;
        }
        
        else if (!transactionData.AccountIdToBalance || transactionData.AccountIdToBalance === 0) {
            SBNotify({ Msg: "To Account is Required", type: "error" });
            saveSuccess = false;
        }
        else if (!transactionData.AssetLotId || transactionData.AssetLotId === 0) {
            SBNotify({ Msg: "Lot is Required", type: "error" });
            saveSuccess = false;
        }
        else if (!transactionData.AssetId || transactionData.AssetId === 0) {
            SBNotify({ Msg: "Asset is Required", type: "error" });
            saveSuccess = false;
        }
        else if (!transactionData.PortfolioId || transactionData.PortfolioId === 0) {
            SBNotify({ Msg: "Portfolio is Required", type: "error" });
            saveSuccess = false;
        }
       
        else if (!transactionData.TransDate) {
            SBNotify({ Msg: "Please Choose Transaction Date", type: "error" });
            saveSuccess = false;
        }
        if (saveSuccess) {
            sbaAxios({
                url: `${insertUpdateReceiveCash}`,
                method: "post",
                data: savedata,
            })
                .then((response) => {
                    if (response) {
                        SBNotify({
                            type: "success",
                            Msg: "ReceiveCash added Successfully",
                        });
                        navigateBack();
                       
                    } else {
                        SBNotify({
                            type: "error",
                            Msg: `Failed to Update`,
                        });
                    }
                })
                .catch(() => { });
        }
    }
    const navigateBack = () => {
        if (objType === 1)
            history(`${UrlPath.Transactions}${transactionData.AssetId}`);
        if (objType === 3)
            history(`/${UrlPath.portfolioTransaction}${transactionData.PortfolioId}`);
    };

    const handleClick = () => {
        setShowModal(true);

    };

    const closeModal = () => {
        setShowModal(false);
    }

  

    return (
        <>
            <TopBar label={"Transactions"} />
            <div id="ReceiveCash" className="mainContentData">
                <BreadCrumbs Levels={Level} />
                <div className="container-fluid p-3">
                    <div className="detail p-4">
                        <div className="row m-0">
                            <div className="row mb-4">
                                <div className="col-md-4">
                                    <label className="mb-1 label">Status<span class="mandatory">*</span></label>
                                    <div>
                                        <SBADropDown
                                            className="w-75"
                                            data={statusDS}
                                            textField={"TransStatus"}
                                            valueField={"TransStatusId"}
                                            value={statusVal.TransStatus ? statusVal : statusDS[2]}
                                            onChange={statusDDChng}

                                        />
                                    </div>
                                </div>
                                <div className="col-md-3">
                                </div>
                                <div className="col-md-4">
                                    <label className="mb-1 label">Portfolio<span class="mandatory">*</span></label>
                                    <div>
                                        <SBAComboBox
                                            className="w-75"
                                            data={portfolioList}
                                            textField={"PortfolioName"}
                                            valueField={"PortfolioId"}
                                            onChange={portfolioDDChng}
                                            onFilterChange={portfolioFilterChange}
                                            value={portfolioVal}
                                            disabled={iseditable}
                                        />
                                    </div>

                                </div>
                              
                             
                            </div>
                            <div className="row mb-4">

                                <div className="col-md-4">
                                    <label className="mb-1 label">Asset<span class="mandatory">*</span></label>
                                    <div>
                                        <SBAComboBox
                                            className="w-75"
                                            data={AssetList}
                                            textField={"AssetName"}
                                            valueField={"AssetId"}
                                            onChange={assetDropdown}
                                           // onFilterChange={AssetFilterChange}
                                            value={AssetVal}
                                            disabled={iseditable}
                                        />
                                    </div>

                                </div>
                                <div className="col-md-3">
                                </div>
                                <div className="col-md-4">
                                    <label className="mb-1 label">Lot<span class="mandatory">*</span></label>
                                    <div>
                                        <SBADropDown
                                            className="w-75"
                                            data={assetLots}
                                            textField={"AssetLotName"}
                                            valueField={"AssetLotId"}
                                            name="AssetLotId"
                                            onChange={(e) => lotDropdown(e)}
                                            value={AssetLotsVal}
                                            disabled={iseditable}
                                        />
                                    </div>
                                </div>
                              
                            </div>
                            <div className="row mb-4">
                                <div className="col-md-4">
                                    <label className="mb-1 label">To Account<span class="mandatory">*</span></label>
                                    <div>
                                        <SBAComboBox
                                            className="w-75"
                                            data={ToAccountAccount}
                                            textField={"AssetName"}
                                            valueField={"AssetId"}
                                            value={ToAccountsVal}
                                            onChange={ToAccountDropdown}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-3">
                                </div>
                                <div className="col-md-4">
                                    <label className="mb-1 label">Transaction Date</label>
                                    <span class="mandatory">*</span>
                                    <div className="d-flex gap-2">
                                        <SBDatePicker
                                            className="w-75"
                                            value={moment(transactionData.TransDate)}
                                            onChange={(e) => transdateChange(e)}
                                        />
                                    </div>
                                </div>
                            </div>


                        </div>


                         <div>                       
                            {Isgrid && (  <div class="form-group">
                                <div class="col-sm-12">
                                    <div className="scrollable-table" style={{ height: "200", width: "83%", overflowY: 'scroll' }}>

                                            <table
                                                class="table table-striped"
                                                id="RedeemTable"
                                                border="1"
                                                ref={tableRef}
                                            >
                                                <thead style={{ position: 'sticky', top: '0' }}>
                                                    <tr>
                                                    <th style={{ textAlign: 'center', paddingRight: "120px"}}> Lot </th>
                                                        <th>Init Allocation Date</th>
                                                        <th>Cash In Holdbacks</th>
                                                        <th>Cash To Receive </th>
                                                    <th style={{ textAlign: 'center' }}>Receive All Cash</th>
                                                    </tr>
                                                </thead>
                                                <tbody>

                                                {griddata.ChildDetails && griddata.ChildDetails.length > 0 && griddata.ChildDetails.map((item, parentIndex) => (

                                                        <tr key={parentIndex}>
                                                        <td style={{ width: "300px" }}>
                                                                {item.AssetLotName}
                                                            </td>
                                                            <td>                                                       
                                                            {moment(item.InitialAllocationDate).format("MM-DD-YYYY")}
                                                            </td>
                                                            <td>
                                                          
                                                            {currencyFormatter(item.AvailableCashAmount, 2)}
                                                            </td>
                                                            <td>
                                                                <SBACurrencyInput
                                                                key={parentIndex + "text4"}                                                          
                                                                value={item.TOCashReceive.toFixed(2)}
                                                                id={"txt_Toreceivecash_" + item.Id + ""}
                                                                disabled={item.ReceiveAll}
                                                                onBlur={(e) => ToreceivecashOnchange(e,item.Rowid)}
                                                                //decimalsLimit={2}
                                                                disableGroupSeparators={false}
                                                                />
                                                            </td>
                                                        <td style={{ textAlign: 'center' }}>
                                                            <input
                                                                type="checkbox"
                                                                key={parentIndex + "text5"}
                                                                checked={item.ReceiveAll}
                                                                onChange={(e) => {
                                                                    handleCheckboxChange(e, item.Rowid);
                                                                }}
                                                            />
                                                        </td>


                                                        </tr>
                                                    ))}

                                                </tbody>
                                                <tfoot>

                                                </tfoot>
                                            </table>



                                    </div>
                                </div>
                                
                            </div>)}
                        </div>

                       
                        <span>
                            <div className="row mb-4" style={{marginTop:'20px'}}>
                                <div className="col-md-3">
                                 </div>
                                <div className="col-md-4">
                                    <div><Link className="noUnderLine" onClick={handleClick}>USD</Link></div>
                                    <label className="mb-1 label">Total Cash Received</label>

                                    <div className="d-flex gap-2">                                    
                                        <input className="form-control w-75" disabled={true} type="text"
                                            
                                            value={currencyFormatter(transactionData?.TransAmount,2)} />
                                        
                                    </div>
                                </div>
                                
                                <div className="col-md-4">
                                    <div> <Link className="noUnderLine" onClick={handleClick}>{portfolio?.CurrencyCode}</Link><span style={{marginLeft:'8px'}}>({currencyFormatter(transactionData.ExchangeRate, 2)})</span></div>
                                    <label className="mb-1 label">Local Amount</label>
                                    <div className="d-flex gap-2">
                                        <input className="form-control w-75" disabled={true} type="text" value={currencyFormatter(transactionData.LocalAmount,2)}/>
                                       
                                    </div>
                                </div>
                            </div>
                        </span>
                            
                        
                        <div className="row">
                            <div className="col-md-8 mb-4">
                                <label className="mb-1 label">Description</label>
                                <textarea
                                    style={{ height: '100px', width: "126%", }}
                                    className="form-control"
                                    type="text"
                                    name="TransDescription"
                                    value={transactionData?.TransDescription}
                                    onChange={(e) => { setTransactionData(value => ({ ...value, TransDescription: e.target.value })) }}
                                />
                            </div>
                        </div>
                        <div
                            className="m-3 d-flex justify-content-end"
                            style={{ paddingBottom: "15px",  paddingRight: "220px" }}
                        >
                            <button className="s-sm-btn" onClick={navigateBack}>
                                Cancel
                    </button>

                            {transactionId !== 0 ? (

                                <button className="ms-2 p-sm-btn" disabled={!transactionEditAccess || transactionData.IsLocked} onClick={saveReceiveCash}>
                                    Save
                                </button>
                            ): (

                                    <button className="ms-2 p-sm-btn" disabled={false} onClick={saveReceiveCash}>
                                        Save
                                    </button>
                                )}


                        </div>


                    </div>
                </div>
          
            </div>
            <ExchangeRateModal showModal={showModal} value={transactionData?.ExchangeRate} closeModal={()=>{setShowModal(false)}} onBlur={(e)=>exchangeRateChange(e)}></ExchangeRateModal>
            <ToastContainer></ToastContainer>
        </>
    );

}
const getAssetByID = async (AssetID) => {
    try {
        const response = await sbaAxios({ url: assetDetailsUrl + AssetID });
        return response;
    }
    catch (e) {
        console.log(e, 'Error Fetching the Asset details')
        return {};
    };
};

const getPortfolioDetailsByID = async (portfolioId) => {
    try {
        const response = await sbaAxios({ url: getPortfolioDetailAPI + portfolioId });
        return response;
    }
    catch (e) {
        console.log(e, 'Error Fetching the portfolio details')
        return {};
    };
};
var date = new Date();
var TransactionDate = new Date(date.getFullYear(), date.getMonth() + 1, 1);

const plainGriddata = {
    "ChildDetails":
        [{
            "AssetLotId": 0,
            "AssetLotName": "",
            "InitialAllocationDate": "",
            "AvailableCashAmount": 0,
            "TOCashReceive": 0,
            "ReceiveAll": true,
            "TransId": 0,
    }]}

const plainReceivecash = {
    "TransId": 0,
    "TransTypeId": 5,
    "TransTypeName": "Receivecash",
    "PortfolioId": 0,
    "PortfolioName": "",
    "AssetId": 0,
    "AssetName": "",
    "ShareclassId": 0,
    "ShareClassName": "",
    "AssetLotId": 0,
    "AssetLotName": "",
    "AssetLotAssetId": 0,
    "AssetLotAssetName":"",
    "AccountIdToBalance": 1,
    "AccountIdToBalanceName": "CASH",
    "TradeStatusId": 2,
    "TradeStatusName": "Executed",
    "TransDate": TransactionDate,
    "TransAmount": 0,
    "TransPercentage": 0,
    "LocalAmount": 0,
    "Shares": 0,
    "NAV": 0,
    "NoofShares": 0,
    "CurrencyId": 0,
    "CurrencyCode": "",
    "ExchangeRateId": 0,
    "ExchangeRate": "1.00",
    "TotalRedemptionAmount": "",
    "RedemptionFee": 0,
    "TotalPosition": 100,
    "IsFullRedemption": false,
    "IsInsurance": false,
    "IsFee": false,
    "IsCommitmentRelease": false,
    "TransDescription": "",
    "ModifiedById": 0,
    "ModifiedByName": "",
    "IsFIFO": false,
    "ChildDetails": [{
        "AssetId": 0,
        "AssetLotId": 0,
        "AssetLotName": "",
        "AssetName": "",
        "InitialAllocationDate": "",
        "ModifiedById": 0,
        "ModifiedByName": "",
        "NrOfShares": 0,
        "ShareClassName": "",
        "ShareclassId": 0,
        "TotalNrOfShares": 0,
        "TotalPosition": 0,
        "TransAmount": 0,
        "TransDate": TransactionDate,
        "TransDescription": "",
        "TransId": 0,
        "TransPercentage": 0,
        "TransTypeId": 5,
        "TransTypeName": "Receivecash",
        "AvailableCashAmount": 0
    }
    ]
}